module.exports = __webpack_public_path__ + "assets/img/6d1e66d7ca7758a8ae59a4df4d04e05b.png";